import Cookies from 'js-cookie'

const getTokenKey = function () {
  return 'glows_auth_token'
}

export const getDomain = function () {
  try {
    if (/^(\d+\.){3}\d+$/.test(location.hostname)) {
      return false
    }

    const topLevelDomain = location.hostname.split('.').slice(-2).join('.')

    if (topLevelDomain.includes('.')) {
      return topLevelDomain
    }
  } catch (error) {
    console.error(error)
  }

  return false
}

export function getToken() {
  return Cookies.get(getTokenKey())
}

export function setToken(token: string, needSave: boolean) {
  const config: Record<string, any> = {}
  if (needSave) {
    config.expires = 30
  }

  return Cookies.set(getTokenKey(), token, config)
}

export function removeToken() {
  const tokenKey = getTokenKey()
  const domain = getDomain()
  Cookies.remove(tokenKey)

  // remove .glows.ai token to prevent jwt expired issue
  if (domain) {
    Cookies.remove(tokenKey, { domain })
  }
}
